'use client'

import { Icon } from '@components/primitives/Icon'
import { classMerge } from '@components/utilities/classMerge'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { trackEvent } from '@lib/tracking'
import type { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { useToggleMapView } from '@modules/trials/search/map/toggleMapView'

export default function ViewToggleButton({
  className,
  eventLabel,
  icon,
  isActive,
  label,
  mapView,
}: {
  className?: string
  eventLabel: TrackingEvents
  icon: IconDefinition
  isActive: boolean
  label: string
  mapView: boolean
}) {
  const toggleMap = useToggleMapView()
  return (
    <button
      className={classMerge(
        'flex items-center justify-center gap-2 rounded-lg border-2 antialiased',
        isActive
          ? 'border-primary300 bg-primary100 shadow'
          : 'border-neutral200 bg-white',
        className,
      )}
      onClick={() => {
        toggleMap(mapView)
        trackEvent(eventLabel)
      }}
    >
      <Icon className='text-primary600' icon={icon} />
      <span className='text-sm font-bold leading-normal text-neutral900 antialiased'>
        {label}
      </span>
    </button>
  )
}
